import React, { useCallback, useState, useEffect, useRef } from 'react';
import './style.css';
import { Layout, Breadcrumb, Popconfirm, Button, Form, Input, Row, Col, Pagination, Carousel } from 'antd';
import { MinusCircleOutlined, PlusOutlined, EditOutlined, DeleteOutlined, InboxOutlined, CaretRightOutlined, CaretLeftOutlined } from '@ant-design/icons';
import FormBuilder from 'antd-form-builder'
import Container from '../Layout/Container';
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { Link } from 'react-router-dom';
import Can from '../../config/Can';
import { DistributionListSelector, clearState, updateDistributionList, AddDistributionList, getAllDistributionList, deleteDistributionList } from './DistributionListSlice';
import { ceil, floor } from 'lodash';
const { Header, Content, Footer } = Layout;



export default function DistributionList() {

  const dispatch = useDispatch();
  const [isLoading, setLoading] = React.useState(false);
  const [isToast, setToast] = React.useState(false);
  const [distributionlistData, setDataSource] = useState([]);
  const [ViewModeEdit, setViewModeEdit] = useState(true);
  const [formDr] = Form.useForm()
  const formRef = useRef(null);
  const [updateduuid, setupdateduuid] = useState('');
  const [addList, setAddList] = useState(true)
  const [pending, setPending] = useState(false)
  const [page, setPage] = useState(1);
  const [removeEmptyMsg, setRemoveEmptyMsg] = useState(true);
  const [state, setState] = useState({})
  const [ViewModeListEdit, setViewModeListEdit] = useState(true);
  const [BackwardBtnStatus, setBackwardBtnStatus] = useState(true);
  const [ForwardBtnStatus, setForwardBtnStatus] = useState(false);
  const [form] = Form.useForm()
  let nav = useRef(null);
  //const [nav, setnav] = React.useState(null);
  const [media, setmedia] = React.useState(null);

  const { isFetching, isSuccess, isError, errorMessage, response, listadded, distributionList, listCount, listUpdated } = useSelector(
    DistributionListSelector
  );

  useEffect(() => {
    setLoading(true);
    dispatch(clearState());
    dispatch(getAllDistributionList(page));
  }, []);

  useEffect(() => {
    if (isError) {
      setLoading(false);
      toast.error(errorMessage);
    }
    if (isSuccess) {
      setLoading(false);
      setDataSource(distributionList);
    }

    if (listadded) {
      setAddList(true);
      setState({});
      dispatch(getAllDistributionList(page));
      dispatch(clearState());
    }

    if (listUpdated) {
      setViewModeEdit(true)
      setPending(false);
      setState({});
      dispatch(getAllDistributionList(page));
      dispatch(clearState());
    }
  }, [isError, listCount, listadded, listUpdated, isSuccess, setLoading, distributionList, setDataSource]);




  const checkUUid = (listInfo) => {
    let listExplode = listInfo.uuid.split('-');
    let listJoin = listExplode.join('')
    let listname = 'dist_id_' + listJoin;
    setState(prev => ({
      // ...prev,
      [listname]: listInfo.uuid
    }));
    setupdateduuid(listInfo.uuid);
    // console.log('listInfo.uuid =>', listInfo.uuid);
  }

  const removeCheckedUUid = (listInfo) => {
    let listExplode = listInfo.uuid.split('-');
    let listJoin = listExplode.join('')
    let listname = 'dist_id_' + listJoin;
    // console.log(listname)
    setState(prev => ({
      ...prev,
      [listname]: null
    }));
    setupdateduuid('');
  }

  const getUpdateMeta = (listInfo) => {
    const meta = {
      disabled: pending,
      initialValues: listInfo,
      fields: [
        {
          key: 'bd_listContent',
          renderView: (v) => {

            return (
              <>
                <h2 className="distribution-list-title">
                  <span className="distribution-list-title-name">{listInfo.name}</span>
                  <span className="distribution-list-edit-dlt-btns">
                    <Can I="dashboardTab" a="editDistributionList">
                      {() => <button type="link" onClick={() => {
                        checkUUid(listInfo);
                      }}><EditOutlined /></button>}
                    </Can>

                    {/* <button type="link" onClick={() => { 
                  checkUUid(listInfo);
                    }}><EditOutlined /></button> */}

                    <Can I="dashboardTab" a="deleteDistributionList">
                      {() => <Popconfirm
                        title={`Are you sure you want to delete this ${listInfo.name} ?`}
                        onConfirm={(e) => handleDeleteList(e, listInfo)}
                        okText="Yes"
                        cancelText="No"
                        icon={<DeleteOutlined style={{ color: 'red' }} />}
                      >
                        <button type="link" ><DeleteOutlined /></button>
                      </Popconfirm>}
                    </Can>

                    {/* <Popconfirm
                  title={`Are you sure you want to delete this ${listInfo.name} ?`}
                  onConfirm={(e)=>handleDeleteList(e,listInfo)}
                  okText="Yes"
                  cancelText="No"
                  icon={<DeleteOutlined style={{ color: 'red' }} />}
                >
                  <button type="link" ><DeleteOutlined /></button>
                  </Popconfirm> */}

                  </span>
                </h2>

                <ul className="distribution-list-ul">{
                  listInfo.listContent.map((v, i) => {
                    return (
                      <li key={i}>{v}</li>
                    )
                  })
                }</ul>
              </>
            )
          },
          widget: () => {
            let bdrref = [];

            if (listInfo.listContent) {
              bdrref.push({ listContent: listInfo.name })
              listInfo.listContent.forEach(v => {
                bdrref.push({ listContent: v })

              });
              // console.log(bdrref);
            }

            let elistExplode = listInfo.uuid.split('-');
            let elistJoin = elistExplode.join('')
            let elistname = 'listid_' + elistJoin;

            return (
              <>
                <Form.List name="arr_listContent" key={listInfo.uuid} initialValue={bdrref}>
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, fieldKey, ...restField }) => (
                        <Form.Item
                          {...restField}
                          name={[name, "listContent"]}
                          label={
                            key == 0 ? (
                              <Button className="distribution-list-addmore-button" onClick={() => add()} type="link">+ Add More</Button>
                            ) : (
                              <Button className="distribution-list-remove-input-button" onClick={() => remove(name)} type="link"><MinusCircleOutlined /></Button>
                            )
                          }
                          fieldKey={[fieldKey, "listContent"]}
                          rules={[{ required: true, message: "List is required" }]}
                          requiredMark={"optional"}
                          className="distribution-list-input-box"
                        >
                          <Input className="formInput" placeholder="Add Name" onClick={(e) => { return true; }} />
                        </Form.Item>
                      ))}
                    </>
                  )}
                </Form.List>
              </>
            )
          },

        },
      ],
    }
    return meta
  }


  // const handleFinishUpdate = useCallback(values => {

  //   console.log(values)
  //   setPending(true)
  //   let newList = [];
  //   for (let i = 1; i < values.arr_listContent.length; i++) {
  //     newList.push(values.arr_listContent[i].listContent);
  //   }

  //   let data = {
  //     "uuid": updateduuid,
  //     "name": values.arr_listContent[0].listContent,
  //     "listContent": newList
  //   }

  //   // console.log("updated data = "+JSON.stringify(data))
  //   dispatch(updateDistributionList(data));
  // });


  const handleFinishUpdate = useCallback(values => {
    // formRef.current.submit()

    // console.log('curent =>',values)
    // setPending(true)
    let newList = [];
    for (let i = 1; i < values.arr_listContent.length; i++) {
      newList.push(values.arr_listContent[i].listContent);
    }

    let data = {
      "uuid": updateduuid,
      "name": values.arr_listContent[0] && values.arr_listContent[0].listContent === values.list_name ? values.list_name : values.arr_listContent[0].listContent,
      "listContent": newList
    }

    // console.log("updated data = " + JSON.stringify(data))
    dispatch(updateDistributionList(data));
  });


  const handleDeleteList = (e, data) => {

    e.preventDefault();
    if (page === 1) {
      dispatch(deleteDistributionList(data.uuid));
      setTimeout(() => {
        dispatch(getAllDistributionList(page));
      }, 1000);

    }
    else if (distributionlistData.length === 1 && page !== 1) {
      dispatch(deleteDistributionList(data.uuid));
      setTimeout(() => {
        dispatch(getAllDistributionList(page - 1));
      }, 1000);
      if (page === 2) {
        setPage(page - 1)
      }
    }
    else {
      dispatch(deleteDistributionList(data.uuid));
      setTimeout(() => {
        dispatch(getAllDistributionList(page));
      }, 1000);

    }
    setRemoveEmptyMsg(false)

  }

  const handleOnMouseDown = (e) => {

    // e.preventDefault() // stops weird link dragging effect
  }

  const handleOnClick = (e) => {
    e.stopPropagation()
    e.preventDefault()
  }

  const onClickBackward = () => {
    if (page > 1) {
      setBackwardBtnStatus(false);
      setForwardBtnStatus(false);
      let p = page - 1;
      setPage(p)
      // console.log("backward= ", p);
      dispatch(getAllDistributionList(p));
    }
    else {
      setBackwardBtnStatus(true);
      setForwardBtnStatus(false);
    }
  }

  const onClickForward = () => {

    if (ceil(listCount / 5) > page) {
      let p = page + 1;
      setPage(p)
      // console.log("Forward= ", p);
      dispatch(getAllDistributionList(p));
      setBackwardBtnStatus(false);
      setForwardBtnStatus(false);
    }
    else {
      setForwardBtnStatus(true);
      setBackwardBtnStatus(false);
    }

  }

  return (
    <>
      <Container>
        <Breadcrumb className="distribution-breadcrumb" style={{ paddingLeft: 50, marginBottom: 0 }} separator=">">
          <Breadcrumb.Item><Link to="/dashboard">Dashboard</Link></Breadcrumb.Item>
          <Breadcrumb.Item><Link to="/distribution-list">Distribution List</Link></Breadcrumb.Item>
        </Breadcrumb>

        <div className="site-layout-content" style={{ backgroundColor: "#ffffff", marginTop: 0, paddingTop: 0 }}>


          <Row gutter={[10, 0]} style={{ backgroundColor: "#ffffff", padding: '23px 15px 23px 20px', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderTop: '1px solid #dfe0eb', borderBottom: '2px solid #e8e8e8' }}>
            <Col span="20">
              <h1 style={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: 22, marginBottom: '0px' }}>Distribution List ({listCount})</h1>
            </Col>
            <Col span="4" style={{ paddingLeft: 25, textAlign: 'right' }}>
              {/* <Button onClick={() => {setAddList(false); setRemoveEmptyMsg(false)}} size="large" style={{borderRadius:5,padding:'6.4px 8px',fontWeight:600,fontSize:14}}  type="primary"  icon={<PlusOutlined />}>Add List</Button> */}
              <Can I="dashboardTab" a="addDistributionList">
                {() => <Link to="/add-distribution-list"><Button size="large" style={{ borderRadius: 5, padding: '6.4px 8px', fontWeight: 600, fontSize: 14 }} type="primary" icon={<PlusOutlined />}>Add List</Button></Link>}
              </Can>
              {/* <Link to="/add-distribution-list"><Button  size="large" style={{borderRadius:5,padding:'6.4px 8px',fontWeight:600,fontSize:14}}  type="primary"  icon={<PlusOutlined />}>Add List</Button></Link>  */}
            </Col>
          </Row>

          <div className="all-forms-wrapper-distribution-list" >
            {
              (listCount > 0) &&
              <button className='prev-next-btns' onClick={onClickBackward} disabled={BackwardBtnStatus}><CaretLeftOutlined /></button>
            }
            {distributionlistData && distributionlistData.map(function (v, i) {
              let listdExplode = v.uuid.split('-');
              let listdJoin = listdExplode.join('')
              let listdname = 'dist_id_' + listdJoin;
              return (

                <Form
                  key={v.uuid}
                  // ref={formRef}
                  ref={state && state[listdname] == v.uuid ? formRef : null}
                  layout="vertical"
                  labelCol={{ span: 16 }}
                  wrapperCol={{ span: 24 }}
                  onFinish={handleFinishUpdate}
                  // onFinish={(values) => this.handleFinishUpdate(values)}
                  className="distribution-list-form "
                  style={{ paddingTop: '20px', backgroundColor: "#ffffff" }}
                >
                  <div key={v.uuid} onClick={e => handleOnClick(e)} onMouseDown={e => handleOnMouseDown(e)}>

                    <Form.Item>
                      <Form.Item name={"list_name"} hidden={true} initialValue={v.name}>
                        <Input className="formInput" placeholder="" />
                      </Form.Item>

                      <FormBuilder name="allData" key={v.uuid} form={form} getMeta={() => getUpdateMeta(v)} viewMode={state && state[listdname] == v.uuid ? false : true} />

                      {state && state[listdname] == v.uuid && (
                        <Form.Item className="form-footer" wrapperCol={{ span: 24, offset: 0 }}>

                          <Button className="list-save-btn" type="primary" onClick={() => formRef.current.submit()} disabled={pending}>
                            {pending ? "Updating..." : "Save"}
                          </Button>
                          <Button className="list-cancel-btn"
                            onClick={() => {
                              removeCheckedUUid(v)
                            }}
                            style={{ marginLeft: "15px" }}
                          >
                            Cancel
                          </Button>
                        </Form.Item>
                      )}
                    </Form.Item>

                  </div>
                </Form>
              );
            })}
            {
              (listCount > 0) &&
              <button className='prev-next-btns' onClick={onClickForward} disabled={ForwardBtnStatus}><CaretRightOutlined /></button>
            }
            {
              (listCount <= 0) &&
              <Row className="no-distributionlist-item-found" gutter={[10, 0]} style={{ backgroundColor: "#ffffff", padding: '25px 30px 10px 30px', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderBottom: '2px solid #e8e8e8', position: 'relative' }}>
                <Col span="24" style={{ textAlign: 'center', padding: '50px' }}>
                  <InboxOutlined />
                  <h2>No distribution list have been added yet!</h2>
                  <h2>Click on <span>"Add List"</span> to start adding the branches</h2>
                </Col>
              </Row>
            }
          </div>
          {/* </Carousel> */}
          {/* </Form> */}

        </div>
      </Container>
    </>
  );
}